import { XesAxios } from '@xes/terra-utils'
import envConfig from './config'
const { env, mock, baseApi, mockApi } = envConfig

let BASE_URL = ''
if (env === 'production') {
  BASE_URL = baseApi
} else {
  BASE_URL = mock ? mockApi : baseApi
}

export default {
  // 征文命题
  articalTopic() {
    return XesAxios.get(`${BASE_URL}/artical/topic`)
  }
}
